import { useEditorContext } from "../../../../context/editorContext/EditorContext";
import { ITemplate } from "../../../../interfaces/editor/Templates";
import { useBoardContext } from "@rastreabilidadebrasil/tageditor";
import { Box, Grid } from "@mui/material";
import TemplateView from "./templateView";

export const emptyTag =
  '{"editor":{"version":"0.0.56"},"tags":{"currentTag":1,"shared":{"byId":{"49eac4d0-0f51-4d95-8d75-5048e8f65b04":{"type":"Workspace","version":"5.2.4","originX":"center","originY":"center","left":971,"top":567.5,"width":252.09,"height":96,"x-type":"workspace","x-id":"49eac4d0-0f51-4d95-8d75-5048e8f65b04","x-index":0, "rx": 2, "ry": 2}}},"byVersion":{}}}';

export const lacreTemplate = `{
  "tags": {
    "shared": {
      "byId": {
        "97af7222-9e08-4576-9b84-34922adefcf2": {
          "top": 567.5,
          "left": 1013,
          "type": "Workspace",
          "x-id": "97af7222-9e08-4576-9b84-34922adefcf2",
          "width": 358,
          "height": 151,
          "x-type": "workspace",
          "originX": "center",
          "originY": "center",
          "version": "5.2.4",
          "x-index": 0
        },
        "da2d18fb-d3fa-4e58-bc07-bd86b8bfc7c4": {
          "type": "image",
          "version": "5.5.2",
          "originX": "center",
          "originY": "center",
          "left": 1013,
          "top": 567.5,
          "width": 358,
          "height": 151,
          "globalCompositeOperation": "source-over",
          "x-id": "da2d18fb-d3fa-4e58-bc07-bd86b8bfc7c4",
          "src": "data:image/svg+xml;base64,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",
          "x-type": "LACREGRAV",
          "selectable": false,
          "evented": false
        }
      }
    },
    "byVersion": {},
    "currentTag": 1
  },
  "editor": {
    "version": "0.0.53"
  }
}
`;

export default function GridTemplatesEditor(props: {
  handleSelectedTemplate: Function;
  handleDelete: Function;
  handleEditTemplate: Function;
  templateList: ITemplate[];
  userCanEditOrDeleteTemplate: {
    userCanDeleteTemplate: boolean;
    userCanEditTemplate: boolean;
  };
}) {
  const {
    handleSelectedTemplate,
    handleDelete,
    handleEditTemplate,
    templateList,
    userCanEditOrDeleteTemplate,
  } = props;

  const { boardConfig } = useBoardContext();

  const { produtoSelecionado } = useEditorContext();

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item md={4} key={0}>
          <TemplateView
            handleSelectedTemplate={props.handleSelectedTemplate}
            handleDelete={() => undefined}
            handleEditTemplate={() => undefined}
            emptyJson={produtoSelecionado?.codigo === "LACREGRAV" ? lacreTemplate : emptyTag}
            template={{
              idTemplate: 0,
              nomept: "",
              nomeen: "",
              nomees: "",
              json: "",
              idTema: 0,
            }}
            boardConfig={boardConfig}
            userCanEditOrDeleteTemplate={userCanEditOrDeleteTemplate}
          />
        </Grid>
        {templateList?.map((template) => {
          return (
            <Grid item md={4} key={template.idTemplate}>
              <TemplateView
                emptyJson={emptyTag}
                handleSelectedTemplate={handleSelectedTemplate}
                handleDelete={handleDelete}
                handleEditTemplate={handleEditTemplate}
                template={template}
                boardConfig={boardConfig}
                userCanEditOrDeleteTemplate={userCanEditOrDeleteTemplate}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
